import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export interface BookingTimelineEntry {
  key: string;
  at: string;
  title: string;
  /** Who did it, e.g. "Traveler · Asha". */
  actor?: string;
  detail?: string;
}

/** Vertical, time-ordered list of what happened to a booking. */
export function BookingTimeline({ entries }: { entries: BookingTimelineEntry[] }) {
  if (entries.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        No history recorded.
      </Typography>
    );
  }

  return (
    <Box component="ol" sx={{ listStyle: 'none', m: 0, p: 0 }}>
      {entries.map((entry, index) => (
        <Box
          component="li"
          key={entry.key}
          sx={{ display: 'flex', gap: 1.5, pb: index === entries.length - 1 ? 0 : 2, position: 'relative' }}
        >
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', pt: 0.6 }}>
            <Box sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: 'primary.main', flexShrink: 0 }} />
            {index < entries.length - 1 && (
              <Box sx={{ width: 2, flex: 1, bgcolor: 'divider', mt: 0.5 }} />
            )}
          </Box>
          <Box sx={{ minWidth: 0 }}>
            <Typography variant="body2" fontWeight={700}>
              {entry.title}
            </Typography>
            <Typography variant="caption" color="text.secondary" component="div">
              {new Date(entry.at).toLocaleString('en-IN', {
                day: '2-digit',
                month: 'short',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
              })}
              {entry.actor ? ` · ${entry.actor}` : ''}
            </Typography>
            {entry.detail && (
              <Typography variant="body2" sx={{ mt: 0.5, overflowWrap: 'anywhere' }}>
                {entry.detail}
              </Typography>
            )}
          </Box>
        </Box>
      ))}
    </Box>
  );
}
